import React, { useState, useEffect } from 'react';
import { Footer, Header } from "./headerFooter";
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { useNavigate } from 'react-router-dom';
import { getHost } from './config';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";

const ContactSupport = () => {
  // State to handle input values
  const [first_name, setFirstName] = useState('');
  const [last_name, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    if (!token) {
        navigate('/', { replace: true });
    }
  }, [token, navigate]);
  
  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      // Call the /register endpoint with the attributes needed
      const url = `${getHost()}/api/contact-support`
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          first_name,
          last_name,
          email,
          subject,
          message
        }),
      });

      const data = await response.json();

      // Check if the response is OK
      if (response.ok) {
        setSuccess(data.message || "Επιτυχημένη αποστολή. Θα έχετε σύντομα απάντηση στο e-mail που έχετε δηλώσει");
        setError('');
      } else {
        setError(data.message || "Η αποστολή δεν ολοκληρώθηκε. Προσπαθήστε ξανά.");
        setSuccess('');
      }

    } catch (error) {
      // Handle errors (e.g., wrong credentials)
      setError('Η αποστολή δεν ολοκληρώθηκε. Προσπαθήστε ξανά.');
      setSuccess('');
    }
  };

  const handleLogout = () => {
        // Clear the authToken from localStorage
        localStorage.removeItem('authToken');
        localStorage.setItem('logout-event', Date.now());

        // Redirect to the login page
        navigate('/', { replace: true });
    }

  const isFormValid = first_name !== '' && last_name !== '' && email !== '' && subject !== '' && message !== '';
  
  return (
    <div id="root">
      <Header handleLogout={handleLogout}/>
      <main className='center-container'>
        <Container className='custom-container p-3'>
          {error && <Alert key="danger" variant="danger">{error}</Alert>}

          {/* Success message */}
          {success ? (
            <div className="result">
             <Alert key="success" variant="success">{success}</Alert>
             <Button onClick={() => navigate('/main')} variant="danger">Επιστροφή στην οθόνη εισόδου</Button>
            </div>
          ) : (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="registerForm.first_name">
                <Form.Label className="custom-label">Όνομα</Form.Label>
                <Form.Control className="custom-form" value={first_name} onChange={(e) => setFirstName(e.target.value)} required/>
              </Form.Group>
              <Form.Group className="mb-3" controlId="registerForm.last_name">
                <Form.Label className="custom-label">Επώνυμο</Form.Label>
                <Form.Control className="custom-form" value={last_name} onChange={(e) => setLastName(e.target.value)} required/>
              </Form.Group>
              <Form.Group className="mb-3" controlId="registerForm.email">
                <Form.Label className="custom-label">e-mail</Form.Label>
                <Form.Control className="custom-form" type="email" value={email} onChange={(e) => setEmail(e.target.value.trimEnd())} required/>
              </Form.Group>
              <Form.Group className="mb-3" controlId="registerForm.subject">
                <Form.Label className="custom-label">Θέμα</Form.Label>
                <Form.Control className="custom-form" value={subject} onChange={(e) => setSubject(e.target.value)} required/>
              </Form.Group>
              <Form.Group className="mb-3" controlId="registerForm.message">
                <Form.Label className="custom-label">Κείμενο</Form.Label>
                <Form.Control className="custom-form" as="textarea" rows={4} value={message} onChange={(e) => setMessage(e.target.value)} required/>
              </Form.Group>
              <Button variant="danger" type="submit" disabled={!isFormValid}>Αποστολή</Button>
            </Form>
          )}
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default ContactSupport;